import { render } from "./featuredDoctorsSection.vue?vue&type=template&id=7f2d4c03"
import script from "./featuredDoctorsSection.vue?vue&type=script&lang=js"
export * from "./featuredDoctorsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__